import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import Header from "../../components/ForPages/Header";
import "./Landing.css";
// import ScrollAnimation from "react-animate-on-scroll";
import Footer from "../../components/ForPages/Footer";
import jwt_decode from "jwt-decode";
import axiosInstance from "../../utils/config";

const Landing = () => {
  document.body.style.backgroundColor = "#FFF";
  const [isLoggedIn, setIsLoggedIn] = useState({ token: null, user: "" });
  useEffect(() => {
    const autoLogUserIn = () => {
      const email = "testing@testing.com";
      const password = "0987654321";

      axiosInstance
        .post("/login", { Email: email, Password: password })
        .then((data) => {
          localStorage.setItem("skiUserToken", data.data.token.split(" ")[1]);
          setIsLoggedIn({
            token: data.data.token.split(" ")[1],
            user: data.data.data?.AccountType,
          });
        });
    };

    document.title = "Ski Design | Generate Your Next Social Media Post Design";
    let token = localStorage?.getItem("skiUserToken");
    if (token) {
      let decodedToken = jwt_decode(token);
      const currentDate = new Date();
      if (decodedToken.exp > currentDate.getTime()) {
        if (decodedToken.AccountType === "client") {
          setIsLoggedIn({ token: token, user: "client" });
        } else if (decodedToken.AccountType === "creative") {
          setIsLoggedIn({ token: token, user: "creative" });
        }
      } else {
        autoLogUserIn();
      }
    } else {
      autoLogUserIn();
    }
  }, []);
  return (
    <div className="Landing_page">
      <Header isLoggedIn={isLoggedIn} />
      <div className="Middle-banner">
        <div>
          <h2>Generate Your Next Social Media Post Design</h2>
          <p>
            Ski Studio is a graphic design Web-platform that generates social
            media post designs for busy and non-skilled Small business owners or
            Marketer.
          </p>
          <div className="Landing_more_info w-25">
            {/* <ScrollAnimation animateIn="fadeIn" animateOut="fadeOut"> */}
              <a
                className="shadow-none btn btn-primary"
                data-toggle="modal"
                data-target="#exampleModalCenter"
                style={{ border: "none" }}
                href={
                  window.location.href.search("#freedesigns") === -1
                    ? window.location.href + "#freedesigns"
                    : window.location.href
                }
              >
                Signup It’s Free
              </a>
            {/* </ScrollAnimation> */}
          </div>
        </div>
        <div>
          <img src="./Images/landing_man.png" alt="Landing man" />
        </div>
      </div>
      <div className="free-designs" id="freedesigns">
        <div>
          <h2>Get Free Social Media Designs</h2>
          <p>
            Our Platform enables you to Easily meet your design needs and gives
            your a uniqe branding
          </p>
          <div>
            <div>
              {/* <ScrollAnimation animateIn="fadeIn" animateOut="fadeOut"> */}
                <img src="./Images/target.png" alt="Target" />
              {/* </ScrollAnimation> */}
            </div>
            <div>
              <h4>Our Platform Generate Design for You</h4>
              <p>
                Simply input your design content and our System designs for you.
              </p>
            </div>
          </div>
          <div>
            <div>
              <img src="./Images/mutual-face.png" alt="Mutual faces" />
            </div>
            <div>
              <h4>Choose & Get Unique Design</h4>
              <p>
                Our system designs for you in less than 5 seconds. And shows you
                10 designs to choose from. You have options to edit design,
                text, color, images.
              </p>
            </div>
          </div>
          <div>
            <div>
              <img src="./Images/favorite-feed.png" alt="Favorite feed" />
            </div>
            <div>
              <h4>Download Your Design</h4>
              <p>
                Choose a design and download to your device. You don’t have to
                depend on design agency to get your social media design ready.
              </p>
            </div>
          </div>
          {!localStorage.getItem("skiUserToken") ? (
            <Link
              to="/"
              className="shadow-none btn btn-primary"
              data-toggle="modal"
              data-target="#exampleModalCenter"
            >
              Sign Up
            </Link>
          ) : (
            ""
          )}
        </div>
        {/* <ScrollAnimation animateIn="bounceInRight" animateOut="fadeOut"> */}
          <div>
            <img src="./SVG/tablet_poster.svg" alt="Tablet poster" />
          </div>
        {/* </ScrollAnimation>   */}
      </div>
      <div className="powerful-ai-designer">
        <h2>An Artifical Intelligence Social Media Post Design Platform </h2>
        <div>
          {/* <ScrollAnimation animateIn="bounceInLeft" animateOut="fadeOut"> */}
            <div>
              <img src="./Images/ai-design.png" alt="Ai design" />
            </div>
          {/* </ScrollAnimation> */}
          <div>
            <h2>
              Each person gets a unique & personalize design for their marketing
              needs
            </h2>
            <div>
              <div>
                <img src="./Images/target.png" alt="Target" />
              </div>
              <div>
                <h4>Free design</h4>
                <p>Get 3 free design downloads per month Forever</p>
              </div>
            </div>
            <div>
              <div>
                <img src="./Images/mutual-face.png" alt="Mutual faces" />
              </div>
              <div>
                <h4>Unlimited Design Downloads</h4>
                <p>
                  You can design unlimitedly for a month
                  <span>
                    <Link to="/"> (Request Quote)</Link>
                  </span>
                </p>
              </div>
            </div>
            <div>
              <div>
                <img src="./Images/favorite-feed.png" alt="Mutual faces" />
              </div>
              <div>
                <h4>Payment made easy</h4>
                <p>
                  We accept payment in credit/debit cards and also Mobile Money
                </p>
              </div>
            </div>

            {!localStorage.getItem("skiUserToken") ? (
              <Link
                to="/"
                type="button"
                className="shadow-none btn btn-primary"
                data-toggle="modal"
                data-target="#exampleModalCenter"
                style={{ border: "none" }}
              >
                Get started
              </Link>
            ) : (
              ""
            )}
          </div>
        </div>
      </div>
      <div className="all-in-one-platform">
        <h1>Everything in one Platform</h1>
        <img src="./Images/social-medias.png" alt="All in one platform" />
      </div>
      <div className="begin-discovery">
        <div>
          <h3>
            Get Started now! <br /> Begin your discovery
          </h3>
          <p>
            Signup to the app to personalize your unique business designs,{" "}
            <br /> Post on your social media page at all time anywhere. Stay on
            track <br /> and complete on time!
          </p>
        </div>
        <div>
          <img
            src="./Images/scheduling-woman.png"
            alt="Woman making a schedule"
          />
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default Landing;
